import React from 'react';
import services from '../../services';
import Response from './../../locale/res.json';
import Main from '../../Pages/Demo/main';
import TlkTable from '../tlelrik/table/tlkTable';
import Lang from '../../lang/lang.json'
var moment = require('moment')
const dateFormat = "YYYY-MM-DD HH:mm:ss";

const tableProps = {
    columnkeyMap: {
        "Version": "Version",
        "Modules": "Modules",
        "Actions": "Actions",

        "Data": "Data"
    },
    groupfield: [],
    actionbuttons: {},// Redirect: "Emitir Fatura",
    listApilink: "Revenue/CollectionRevenue/GetAll",
    requestMethod: "post",
    notAction: true,
    deleteAPILink: "/BusEntidadeEstatuto/Delete/",
}
class ParcelVirsion extends React.Component {

    /* Primeiro passo na acomodação da classe */
    constructor(props) {
        super(props);
        this.state = {
            parcelversions: [],
            tableData: [],
            tlkTable: null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */
    componentDidMount() {
        this.getParcelversions();
    }

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.getParcelversions();
        }
    }

    getParcelversions = async () => {
        let res = [];
        let data = {
            "id": parseInt(this.props.id),
            "Filters": null,
            "SortBy": "",
            "IsSortTypeDESC": false,
            "IsPagination": false,
            "Page": 1,
            "PageSize": 10
        }
        if (parseInt(this.props.id) > 0) {
            res = await services.apiCall.requestApi('/Parcel/GetVersionsById', data, 'post')
            if(res){
                this.setState({
                    parcelversions: res,
                    tableData:[]
                }, () => this.findDiffrence())
            }else{
                this.setState({tableData : []})
            }
        }
    }

    findDiffrence = () => {
        console.log("this.state.parcelversions",this.state.parcelversions);
        let parcelversions = [...this.state.parcelversions] || [];
        let tableData = [...this.state.tableData];
        let diff = false;
        for (let i = 0; i < parcelversions.length; i++) {
            if (parcelversions[i + 1]) {
                diff = this.ifDiffrence({ "base": parcelversions[i], "next": parcelversions[i + 1] }, i);
                if (diff) {
                    // diff.version = i;
                    tableData[tableData.length] = diff
                }
            }
        }
        window.localStorage.setItem('table_total', tableData.length);
        this.setState({ tableData }, () => this.createTable());
    }


    ifDiffrence = (data, version) => {
        let changeinModules = [];
        let Action = [];
        let actionArray = "";
        let allArrayObject = ["matrixArticle", "parcelProperty", "parcelExplorer", "legalFramework", "castaparc"]
        let date = moment(data['next']['parcel']['update_at']).format(dateFormat);
        delete data['base']['parcel']['update_at'];
        delete data['next']['parcel']['update_at'];
        if (JSON.stringify(data['base']['parcel']) !== JSON.stringify(data['next']['parcel'])) {
            changeinModules.push('parcel');
            Action.push("Update");
        }

        allArrayObject.map((modulename) => {
            actionArray = this.checkArray(data, modulename);
            if (actionArray) {
                changeinModules.push(modulename);
                Action.push(actionArray);
            }
        });
        if (changeinModules.length > 0) {
            return {
                Modules: changeinModules.join(", "),
                Actions: Action.join(", "),
                Version: version + 1,
                Data: date,
                bothRow: data
            }
        } else {
            return false;
        }
    }

    checkArray = (data, modulename) => {
        let action = [];
        if (JSON.stringify(data['base'][modulename]) !== JSON.stringify(data['next'][modulename])) {
            if (data['base'][modulename].length < data['next'][modulename].length)
                action.push("Add");
            if (data['base'][modulename].length > data['next'][modulename].length)
                action.push("Delete");
            if (data['base'][modulename].length === data['next'][modulename].length)
                action.push("Update");
        }
        if (action.length > 0) {
            return action.join(", ");
        } else {
            return false;
        }
    }



    createTable = () => {
        let columnkeyMap = tableProps.columnkeyMap;
        let columnlist = Object.keys(columnkeyMap).map(function (key) {
            return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
        });
        console.log("this.state.tableData", this.state.tableData);
        let tlkTable = (<TlkTable
            date={new Date()}
            key={2}
            modulename={"parcelversions"}
            noDownloadButton={true}
            notAction={tableProps.notAction}
            list={this.state.tableData}
            groupfield={tableProps.groupfield}
            actionbuttons={tableProps.actionbuttons}
            columnlist={columnlist}
            viewFor={"parcelversions"}
            collepsview={true}
            ActionPerform={(action, id) => this.ActionPerform(action, id)}
        />)
        this.setState({ tlkTable },()=>{
            console.log("tlkTable",this.state.tlkTable);
        });
    }

    ActionPerform = (action, id) => {
    }

    /*  Para renderizar o conteúdo html da página */
    render() {
        return (
            <div>
                <h3>Mudanças de versão</h3>
                {
                    this.state.tlkTable
                }
            </div>
        )
    }
}

export default ParcelVirsion;